import { Injectable } from '@angular/core';

export interface EmbeddingProvider {
  embed(text: string): Promise<number[]>;
}

@Injectable({ providedIn: 'root' })
export class EmbeddingService implements EmbeddingProvider {
  async embed(_text: string): Promise<number[]> {
    throw new Error('Vector retrieval is unavailable until an embedding provider is configured.');
  }
}
